import { CommonModule, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  NgbModal,
  NgbModalModule,
  NgbModalRef,
  NgbPaginationModule,
  NgbTooltip,
} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { RequestManagementService } from '../../Services/request-management.service';
import { OrderManagementService } from '../../Services/order-management.service';
import { MasterInformationService } from '../../Services/master-information.service';
import { DashboardService } from '../../Services/dashboard.service';
import { apiEndPoints } from '../../api/apiEndPoint';
import { LoaderComponent } from '../loader/loader.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-baldia-order-history',
  standalone: true,
  imports: [
    NgFor,
    CommonModule,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgbModalModule,
    NgxSpinnerModule,
    LoaderComponent,
  ],
  templateUrl: './baldia-order-history.component.html',
  styleUrl: './baldia-order-history.component.css',
})
export class BaldiaOrderHistoryComponent implements OnInit {
  // Component State
  activeTab: string = 'total-order';
  searchValue: string = '';
  searchActive: boolean = false;
  activeDropdown: any;
  originalTableData: any;
  filteredTableData: any = [];
  orderForm: FormGroup;
  paymentForm: FormGroup;
  tableHeader = [
    'Order Id',
    'Requestor Type',
    'Requestor Name',
    'Requestor mobile no',
    'Request Date',
    'Scheduled Date',
    'Dumpster Name',
    'Dumpster mobile no',
    'Dump Yard Name',
    'Dump Yard Mobile No',
    'City',
    'Status',
    'Dumpster Payment',
    'Dumpyard Payment',
    'Requestor Payment',
    'Order Timeline',
    'Action',
  ];

  // Pagination variables
  currentPage = 1;
  pageSize = 5; // Adjust the page size according to your needs
  totalItems: number = 0;

  // Available filters for UI
  availableFilters: { [key: string]: string[] } = {};
  selectedOrderId: any;

  invoiceType: string = 'Initial Requestor Invoice';

  orderIdForDownloadInvoice: string = '';

  downloadInvoiceModal: any;

  completedOrders: any[] = [];

  activeOrders: any[] = [];

  cancelledOrders: any[] = [];
  requestData: any;

  cities: any[] = [];

  uniqueCities: string[] = [];

  uniqueyOrderStatus: string[] = ['Completed', 'Cancelled', 'Active'];

  filtersApplied: any[] = [
    { filterType: 'city', searchTerm: 'All' },
    { filterType: 'status', searchTerm: 'All' },
  ];

  filterHistory: any[] = [];

  cityFilterApplied: boolean = false;
  statusFilterApplied: boolean = false;
  dumpsterStatusCode: any;
  dumpyardStatusCode: any;
  requesterStatusCode: any;
  selectedZoneId: any;
  zoneList: any;
  selectedCityId: any;
  cityList: any;
  isLoading: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private requestService: RequestManagementService,
    private toastr: ToastrService,
    private router: Router,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private orderManagementService: OrderManagementService,
    private spinner: NgxSpinnerService,
    private masterService: MasterInformationService,
    private dashService: DashboardService
  ) {
    this.orderForm = this.fb.group({
      userType: ['', { disabled: true }],
      companyName: ['', { disabled: true }],
      mobileNumber: ['', { disabled: true }],
      location: ['', { disabled: true }],
      email: ['', { disabled: true }],
      city: ['', { disabled: true }],
      zone: ['', { disabled: true }],
      reqDate: ['', { disabled: true }],
      scheduledDate: ['', { disabled: true }],
      containerName: ['', { disabled: true }],
      containerCapacity: ['', { disabled: true }],
      containerCount: ['', { disabled: true }],
      rentalDuration: ['', { disabled: true }],
      sar: ['', { disabled: true }],
    });

    this.paymentForm = this.fb.group({
      sarReceivedReq: ['', { disabled: true }],
      sarRefundedReq: ['', { disabled: true }],
      sarDumpster: ['', { disabled: true }],
      sarDumpyard: ['', { disabled: true }],
      sarSmartSort: ['', { disabled: true }],
    });
  }

  ngOnInit() {
    this.getRequestList();
    this.getCityList();
    this.setActiveTab('Pending');
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    this.setData();
  }

  setData() {
    if (!this.originalTableData || this.originalTableData.length === 0) {
      setTimeout(() => this.setData(), 200);
      return;
    }

    if (this.activeTab === 'Pending') {
      this.requestData = this.getPendingOrder();
      console.log('Pending Orders:', this.requestData);
    }

    if (this.activeTab === 'approved') {
      this.requestData = this.getApprovedOrders();
      console.log('Approved Orders:', this.requestData);
    }

    if (this.activeTab === 'Denied') {
      this.requestData = this.getDeniedOrders();
      console.log('Denied Orders:', this.requestData);
    }

    if (this.activeTab === 'Re-Submitted') {
      this.requestData = this.getResubmitOrders();
      console.log('Resubmitted Orders:', this.requestData);
    }

    this.totalItems = this.requestData?.length ?? 0;
    this.currentPage = 1;
  }

  getPendingOrder() {
    return this.originalTableData.filter(
      (data: any) => Number(data.requesterStatusCode) === 100
    );
  }
  getApprovedOrders() {
    const approvedCodes = [
      101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
    ];
    return this.originalTableData.filter((data: any) =>
      approvedCodes.includes(Number(data.requesterStatusCode))
    );
  }

  getDeniedOrders() {
    return this.originalTableData.filter(
      (data: any) => Number(data.requesterStatusCode) == 143
    );
  }

  getResubmitOrders() {
    return this.originalTableData.filter(
      (data: any) => Number(data.requesterStatusCode) == 114
    );
  }

  // Get data from the API
  getRequestList() {
    this.isLoading = true;
    this.requestService
      .getRequestList(
        apiEndPoints.getApproveOrder,
        this.selectedCityId,
        this.selectedZoneId
      )
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.requestData = response.body.details;
          this.originalTableData = [...this.requestData];
          this.filteredTableData = [...this.requestData];
          this.totalItems = this.filteredTableData?.length;
        },
        error: (error) => {
          this.isLoading = false;
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // Correct the pagination logic: Get current page data based on filteredTableData
  get pagedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.requestData?.slice(start, end);
  }

  // Pagination change handler
  pageChanged(page: any): void {
    this.currentPage = page;
  }

  onSearch(event: any): void {
    const searchText = event.target.value.toLowerCase();

    if (searchText) {
      this.requestData = this.requestData.filter(
        (item: any) =>
          (item.orderId && item.orderId.toLowerCase().includes(searchText)) ||
          (item.requestorType &&
            item.requestorType.toLowerCase().includes(searchText)) ||
          (item.requestorName &&
            item.requestorName.toLowerCase().includes(searchText)) ||
          (item.dumpsterName &&
            item.dumpsterName.toLowerCase().includes(searchText)) ||
          (item.dumpsterMobileNo &&
            item.dumpsterMobileNo.toLowerCase().includes(searchText)) ||
          (item.dumpyardName &&
            item.dumpyardName.toLowerCase().includes(searchText)) ||
          (item.dumpyardMobileNo &&
            item.dumpyardMobileNo.toLowerCase().includes(searchText)) ||
          (item.requestorMobile &&
            item.requestorMobile.toLowerCase().includes(searchText)) ||
          (item.currentOrderStatus &&
            item.currentOrderStatus.toLowerCase().includes(searchText)) ||
          (item.city && item.city.toLowerCase().includes(searchText)) ||
          (item.zone && item.zone.toLowerCase().includes(searchText))
      );
    } else {
      this.setData();
    }

    this.totalItems = this.requestData?.length; // Update total items after search
    this.currentPage = 1; // Reset to the first page after searching
  }

  // Reset search
  resetSearch(): void {
    this.searchValue = '';
    this.filteredTableData = [...this.originalTableData]; // Reset to original data
    this.totalItems = this.filteredTableData?.length; // Reset total items count
    this.currentPage = 1; // Reset to the first page
  }

  // Toggle dropdown for filters
  toggleDropdown(header: string): void {
    this.activeDropdown = this.activeDropdown === header ? null : header;
  }

  // Apply selected filter to table data
  applyFilter(event: any, header: string): void {
    const selectedOption = event.target.innerText.trim();
    console.log(`Applying filter for ${header}: ${selectedOption}`);

    this.activeDropdown = null;

    if (!selectedOption) {
      this.filteredTableData = [...this.originalTableData];
    } else {
      this.filteredTableData = this.originalTableData.filter((item: any) => {
        const key = header.toLowerCase();
        const value = item[key];

        if (header === 'Status') {
          const statusValue = item.currentOrderStatus;

          console.log(
            `Checking status for item: ${statusValue}, against filter: ${selectedOption}`
          ); // Log comparison

          if (
            statusValue &&
            statusValue.toLowerCase() === selectedOption.toLowerCase()
          ) {
            return true;
          } else {
            return false;
          }
        }

        // Default filter logic for other columns (City, Zone, etc.)
        return (
          value && value.toLowerCase().includes(selectedOption.toLowerCase())
        );
      });
    }

    // Update the total items after applying the filter
    this.totalItems = this.filteredTableData?.length;
    this.currentPage = 1; // Reset to the first page after applying the filter
  }

  // Clear filter
  clearFilter(): void {
    this.requestData = [...this.originalTableData];

    this.currentPage = 1; // Reset to the first page
  }

  // Get payment details based on row status
  getPaymentDetails(row: any, type: string): string {
    if (row.currentOrderStatus === 'Cancelled') {
      return 'N/A';
    }

    if (row.paymentStatus === 'Completed') {
      return type === 'requestor' ? 'Pending' : 'Completed';
    }

    if (row.paymentStatus === 'Active') {
      return type === 'requestor' ? 'Pending' : 'Pending';
    }

    return 'N/A';
  }

  // ------------------------------- Export to Excel ------------------------------- //
  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.requestData);
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, 'OrderHistory.xlsx');
  }

  // -------------------------------- View Details By Order ID -------------------------------- //

  openDetailModal(modal: any, row: any) {
    this.selectedOrderId = row.orderId;
    const formatDate = (date: string | null): string => {
      if (!date) return '';
      const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      };
      return new Intl.DateTimeFormat('en-GB', options).format(new Date(date));
    };

    const formattedReqDate = formatDate(row.requestDate);
    const formattedScheduledDate = formatDate(row.scheduledDate);

    // Patch the response data into the form
    this.orderForm.patchValue({
      userType: row.requestorType || '',
      companyName:
        row.requestorType == 'Individual Requester'
          ? row.requestorName
          : row.companyName || '',
      mobileNumber: row.requestorMobile || '',
      location: row.resquestorLocation || '',
      email: '',
      city: row.city || '',
      zone: row.zone || '',
      reqDate: formattedReqDate,
      scheduledDate: formattedScheduledDate,
      containerName: row.containerName || '',
      containerCapacity: row.containerCapacity || '',
      containerCount: row.containerCount || '',
      rentalDuration: row.rentalDuration || '',
      sar: row.smartSortAmt || '',
    });

    this.modalService.open(modal, {
      ariaLabelledBy: 'confirmation-modal-title',
    });
  }

  navigate(orderId: any) {
    this.router.navigate(['/view-timeline/' + orderId]);
  }

  openDownloadInvoiceModal(orderId: string, modal: any, data: any) {
    console.log(data);
    this.dumpsterStatusCode = data.dumpsterStatusCode;
    this.dumpyardStatusCode = data.dumpyardStatusCode;
    this.requesterStatusCode = data.requesterStatusCode;
    this.orderIdForDownloadInvoice = orderId;
    this.downloadInvoiceModal = this.modalService.open(modal);
  }

  downLoadInvoice() {
    this.downloadInvoiceModal.close();
    this.spinner.show();

    let api: string = '';
    switch (this.invoiceType) {
      case 'Initial Requestor Invoice':
        api = apiEndPoints.downloadInitialRequestorInvoice;
        break;
      case 'Requestor Refund Invoice':
        api = apiEndPoints.downloadRequestorRefundInvoice;
        break;
      case 'Dumpster Invoice':
        api = apiEndPoints.downloadDumpsterInvoice;
        break;
      case 'Dump Yard Invoice':
        api = apiEndPoints.downloadDumpyardInvoice;
        break;
    }

    this.orderManagementService
      .downloadInvoice(this.orderIdForDownloadInvoice, api)
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          let blob: Blob = response.body as Blob;
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');

          a.download = this.orderIdForDownloadInvoice;
          a.href = url;
          a.click();
        },
        error: (err) => {
          this.spinner.hide();
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  getPaymentStatus(statusCode: any) {
    switch (statusCode) {
      case '135':
        return 'Credited';
      case '142':
        return 'Credited';
      case '113':
        return 'Credited';
      case '111':
        return 'N/A';
      default:
        return 'Payment Pending';
    }
  }

  getCityList() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        if (response.body.details) {
          this.cities = response.body.details;
        } else {
          this.cities = [];
        }

        this.cities.forEach((city) => {
          if (!this.uniqueCities.includes(city.cityName)) {
            this.uniqueCities.push(city.cityName);
          }
        });
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- City Change Dropdown ----------------------------------- //

  // onCityChange(event: Event) {
  //   const selectedCityId = (event.target as HTMLSelectElement).value;
  //   if (selectedCityId === 'all') {
  //     // this.getAllRevenueList();
  //   } else {
  //     this.selectedCityId = selectedCityId;
  //   }
  //   this.getZone();
  //   this.getRequestList();
  // }

  onCityChange(event: Event) {
    const selectedCityId = (event.target as HTMLSelectElement).value;

    if (selectedCityId === 'all') {
      this.filteredTableData = [...this.originalTableData]; // Show all data
    } else {
      this.selectedCityId = selectedCityId;
      this.getZone();
      this.getRequestList();
    }
  }

  // ----------------------------------- Get Zone List API ----------------------------------- //

  getZone() {
    this.dashService
      .getZoneList(apiEndPoints.zoneList, this.selectedCityId)
      .subscribe({
        next: (response: any) => {
          this.zoneList = response.body?.details;
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // ----------------------------------- Zone Change Dropdown ----------------------------------- //

  onZoneChange(event: Event) {
    const selectedZoneId = (event.target as HTMLSelectElement).value;
    this.selectedZoneId = selectedZoneId;
    this.getRequestList();
    console.log(selectedZoneId);
  }

  filterData(filterType: string, searchTerm: string) {
    this.filtersApplied.forEach((filter) => {
      if (filter.filterType == filterType) {
        filter.searchTerm = searchTerm;
      }
    });

    this.requestData = this.originalTableData.filter((data: any) => {
      return this.filtersApplied.every((filter: any) => {
        if (filter.filterType == 'city') {
          return filter.searchTerm == 'All'
            ? data
            : data.city == filter.searchTerm;
        } else if (filter.filterType == 'status') {
          return filter.searchTerm == 'All'
            ? data
            : data.statusToDisplay == filter.searchTerm;
        }

        return true;
      });
    });
  }

  openPaymentPopup(data: any, modal: any) {
    console.log(data);
    this.modalService.open(modal, {
      ariaLabelledBy: 'confirmation-modal-title',
    });

    this.paymentForm.patchValue({
      sarReceivedReq: data.sar,
      sarRefundedReq: data.requestRefundAmt ? data.requestRefundAmt : 'N/A',
      sarDumpster: data.dumbsterAmt,
      sarDumpyard: data.dumbYardAmt,
      sarSmartSort: data.smartSortAmt,
    });
  }

  // ------------------------------- Print List or Download PDF ------------------------------- //

  exportToPDF() {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const pdfFileName = 'OrderHistory_List.pdf';

    const logo = new Image();
    logo.src = 'assets/Images/CDM-01.png';
    logo.onload = () => {
      const logoWidth = 28;
      const logoHeight = 20;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10;
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

      const arabicAddressImg = new Image();
      arabicAddressImg.src = 'assets/Images/arabic address.jpeg';
      arabicAddressImg.onload = () => {
        const arabicImgWidth = 70;
        const arabicImgHeight = 20;
        const arabicImgX = pageWidth - arabicImgWidth - 10;
        const arabicImgY = 10;
        doc.addImage(
          arabicAddressImg,
          'JPEG',
          arabicImgX,
          arabicImgY,
          arabicImgWidth,
          arabicImgHeight
        );

        // Add website below Arabic address image
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 255);
        doc.text(
          'www.smart­sort.net',
          arabicImgX + arabicImgWidth / 2,
          arabicImgY + arabicImgHeight + 5,
          { align: 'left' }
        );

        const englishAddressImg = new Image();
        englishAddressImg.src = 'assets/Images/english address.jpeg';
        englishAddressImg.onload = () => {
          const englishImgWidth = 70;
          const englishImgHeight = 20;
          const englishImgX = 10;
          const englishImgY = 10;
          doc.addImage(
            englishAddressImg,
            'JPEG',
            englishImgX,
            englishImgY,
            englishImgWidth,
            englishImgHeight
          );

          // Add website below English address image
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 255);
          doc.text(
            'www.smart­sort.net',
            englishImgX + englishImgWidth / 11,
            englishImgY + englishImgHeight + 5,
            { align: 'left' }
          );

          // Reset text color to black (optional, in case you add more text later)
          doc.setTextColor(0, 0, 0);

          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          const title = 'Order History List';
          const titleY = logoY + logoHeight + 10;
          doc.text(title, pageWidth / 2, titleY, { align: 'center' });

          // Table headers
          const headers = [
            [
              { content: 'Order Id' },
              { content: 'Requestor' },
              { content: 'Requestor Name' },
              { content: 'Requestor mobile no' },
              { content: 'Requested Date' },
              { content: 'Scheduled Date' },
              { content: 'Dumpster Name' },
              { content: 'Dumpster mobile no' },
              { content: 'Dump Yard Name' },
              { content: 'Dump Yard Mobile No' },
              { content: 'Status' },
              { content: 'Dumpster Payment' },
              { content: 'Dumpyard Payment' },
              { content: 'Requestor Payment' },
            ],
          ];

          let tableBody: any[] = [];
          // Ensure Year is filled for every row
          this.requestData.forEach((user: any) => {
            const formatDate = (dateString: string) => {
              return new Date(dateString).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              });
            };

            const formattedRequestDate = formatDate(user.requestDate);
            const formattedScheduledDate = formatDate(user.scheduledDate);
            const dumpsterPaymentStatus = this.getPaymentStatus(
              user.dumpsterStatusCode
            );
            const dumpyardPaymentStatus = this.getPaymentStatus(
              user.dumpyardStatusCode
            );
            const requesterPaymentStatus = this.getPaymentStatus(
              user.requesterStatusCode
            );

            tableBody.push([
              user.orderId,
              user.requestorType,
              user.requestorName,
              user.requestorMobile,
              formattedRequestDate,
              formattedScheduledDate,
              user.dumbsterCompanyName,
              user.dumpsterMobileNo,
              user.dumpyardCompanyName,
              user.dumpyardMobileNo,
              user.statusToDisplay,
              dumpsterPaymentStatus,
              dumpyardPaymentStatus,
              requesterPaymentStatus,
            ]);
          });

          // Generate table
          autoTable(doc, {
            startY: titleY + 10,
            head: headers,
            body: tableBody,
            styles: {
              fontSize: 8,
              cellPadding: 2,
              lineWidth: 0.3,
              lineColor: [50, 50, 50],
              halign: 'center',
            },
            theme: 'grid',
            headStyles: {
              fillColor: [176, 220, 101],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              lineColor: [50, 50, 50],
              lineWidth: 0.3,
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            margin: { top: titleY + 20 },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            didDrawPage: function (data) {
              const pageCount = doc.getNumberOfPages();
              doc.setFontSize(10);
              doc.text(
                `Page ${pageCount}`,
                pageWidth - 20,
                doc.internal.pageSize.height - 10
              );
            },
          });

          // Save the PDF
          doc.save(pdfFileName);
        };
      };
    };
  }
}
